import { render, staticRenderFns } from "./SearchImageCarousel.vue?vue&type=template&id=5360875e&"
import script from "./SearchImageCarousel.vue?vue&type=script&lang=js&"
export * from "./SearchImageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5360875e')) {
      api.createRecord('5360875e', component.options)
    } else {
      api.reload('5360875e', component.options)
    }
    module.hot.accept("./SearchImageCarousel.vue?vue&type=template&id=5360875e&", function () {
      api.rerender('5360875e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bQye5LDXI9qI/JS/comp/SearchImageCarousel.vue"
export default component.exports